export const userTypes = {
  free: "free student",
  pro: "pro student",
  admin: "admin",
};
